import { render, staticRenderFns } from "./FilterAccordion.vue?vue&type=template&id=a0d04a20&"
import script from "./FilterAccordion.vue?vue&type=script&lang=js&"
export * from "./FilterAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports